import api from './api.service';
class ProfileService {
    private url: string = 'profiles';
    getProfile() {
        return api.get(`${this.url}/me`);
    }
    getProfileFull() {
        return api.get(`${this.url}/me-detail`);
    }
    postProfile(detail:any){
        return api.put(`${this.url}/me `,detail);
    }
    uploadAvatar(img: {file: string}){
        return api.post(`${this.url}/avatar`,img);
    }
    deleteAvatar(){
        return api.delete(`${this.url}/avatar/`);
    }
    uploadCertificate(data: {file: string}){
        return api.post(`${this.url}/certificate`,data);
    }
    deleteCertificate(certificate_id:string){
        return api.delete(`${this.url}/certificate/${certificate_id}`);
    }
}

export const profileService = new ProfileService();
